/*
 * @Description: 引入埋点插件
 * @Date: 2021-12-16 17:52:16
 * @Author: mazexin
 * @LastEditors: hkr
 */

import Monitor from '@kuaizi/monitor-js'
// import vuePlugin from '@kuaizi/monitor-js/lib/vuePlugin'
import qs from 'querystring'

const query = qs.parse(window.location.href.split('?')[1])
const urlRoot = process.env.REACT_APP_BASE_URL
const monitor = new Monitor({
  url: `${urlRoot}/tool/tool/MonitorAppStats/report`,
  app_id: 'communal',
  app_name: '筷子公共页面',
  // token: query.token,
  debug: /^(dev|local)/.test(process.env.REACT_APP_KZ_ENV)
})

// monitor.addPlugin(vuePlugin({
//   vueError: true,
//   isPrintError: true
// })).install()

if (!window.$monitor) window.$monitor = monitor

export default monitor
